exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2ESkpcabrIfdh65rJhAkM8{display:block;width:45%;flex:0 0 auto}._2ESkpcabrIfdh65rJhAkM8 ._2ESkpcabrIfdh65rJhAkM8{width:100%}._2cWbaocsRLePgTQ3IJcn4Z{display:inline-block}", "", {"version":3,"sources":["/var/www/fsa/skopei-portal/src/containers/Test/DateTime/DateTime.scss"],"names":[],"mappings":"AAYA,yBACE,cAAe,AACf,UAAW,AACX,aAAe,CAAE,AACjB,kDACE,UAAY,CAAE,AAElB,yBACE,oBAAsB,CAAE","file":"DateTime.scss","sourcesContent":["/* * * * * * * * *\n * NAMED COLORS  *\n * * * * * * * * */\n/* * * * * * * * * * *\n * INTERFACE COLORS  *\n * * * * * * * * * * */\n/* * * * * * * * *\n * BRAND COLORS  *\n * * * * * * * * */\n/* * * * * * * * * * * * * * *\n * SET DEFAULT BRAND COLORS  *\n * * * * * * * * * * * * * * */\n.d {\n  display: block;\n  width: 45%;\n  flex: 0 0 auto; }\n  .d .d {\n    width: 100%; }\n\n.i {\n  display: inline-block; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"d": "_2ESkpcabrIfdh65rJhAkM8",
	"i": "_2cWbaocsRLePgTQ3IJcn4Z"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"sourceMap":true,"importLoaders":2}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/containers/Test/DateTime/DateTime.scss
// module id = 774
// module chunks = 14